// extracted by mini-css-extract-plugin
export default {"tooltip":"_Q-z","arrow":"aR-z"};